















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import helper from '@/components/Record/Calendar/helper';

@Component
export default class SwiperItem extends Vue {
    @Prop() date!: { year: number; month: number; day: number };

    //选中日期
    get selectedDate() {
        return this.$store.state.selectedDate;
    }

    get dateObject() {
        const date = new Date(this.date.year, this.date.month, 1);
        return {
            year: date.getFullYear(),
            month: date.getMonth(),
            day: date.getDate()
        };
    }

    get currentFirstDay() {
        return helper.getDate(this.dateObject.year, this.dateObject.month, 1);
    }

    get weekDay() {
        return this.currentFirstDay.getDay();
    }

    get startTime() {
        return this.currentFirstDay.getDate() - (this.weekDay);
    }

    get monthDayNum() {
        return (this.weekDay === 5 || this.weekDay === 6 || this.weekDay === 7) ? 42 : 35;
    }

    get calendarArr() {
        const arr = [];
        for (let i = 0; i < this.monthDayNum; i++) {
            arr.push({
                year: this.dateObject.year,
                month: this.dateObject.month,
                day: this.startTime + i,
            });
        }
        return arr;
    }

    changeType(day: any) {
        const dateObject = helper.getDate(day.year, day.month, day.day);
        const object = helper.getNewDate(dateObject);
        return object.year + '-' + (object.month + 1) + '-' + object.day;
    }

    currentMonthMaxDay = () => {
        const date = this.date;
        return new Date(date.year, date.month + 1, 0).getDate();
    };

    prevMonthEndDay = () => {
        const date = this.date;
        const currentMonthLastDay = new Date(date.year, date.month + 1, 0).getDate();
        const end = new Date(
            date.year, date.month, currentMonthLastDay
        );
        return end.getDate();
    };

    getDateHtml = (year: number, month: number, day: number) => {
        return new Date(year, month, day);
    };

    formatDate = (date: number | string) => {
        date = Number(date);
        if (date < 0) {
            date = this.prevMonthEndDay() + date;
        } else if (date === 0) {
            date = this.prevMonthEndDay();
        } else if (date === 1) {
            const ddd = this.dateObject.month + 1;
            if (ddd < 10) {
                date = `0${ddd}` + '月';
            }
            if (ddd >= 10) {
                date = ddd + '月';
            }

        } else if (date > this.currentMonthMaxDay()) {
            if (date - this.currentMonthMaxDay() === 1) {

                const temp = this.dateObject.month + 2;
                if (temp <= 9) {
                    date = (`0${temp}` + '月');
                }

                if(temp == 10){
                    date =(`${temp}` + '月')
                }
                if(temp == 11){
                    date =(`${temp}` + '月')
                }
                if (temp == 12) {
                    date = (`${temp}` + '月');
                }
                if (temp > 12) {
                    date = (`0${temp - 12}` + '月');
                }

            } else {
                date = date - this.currentMonthMaxDay();
            }
        }
        return date < 10 ? `0${date}` : date;
    };

    // 是否是本月
    isCurrentMonth(date: Date) {
        const { year: currentYear, month: currentMonth } =
            helper.getNewDate(helper.getDate(this.date.year, this.date.month, 1));
        const { year, month } = helper.getNewDate(date);

        return currentYear === year && currentMonth === month;
    }

    // 是否是今天
    isCurrentDay(date: Date) {
        const { year: currentYear, month: currentMonth, day: currentDay } =
            helper.getNewDate(helper.getDate(this.date.year, this.date.month, this.date.day));
        const { year, month, day } = helper.getNewDate(date);
        return currentYear === year && currentMonth === month && currentDay === day;
    }

    // 操作点击日期
    handleClickDay(day: { year: number; month: number; day: number }) {
        this.$store.commit('handleClickDay', day);
    }
}
